module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-03@2x-9dd0f97f3197fedf8455539cea71c366.png";